import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const useSystemStatus = () => {
  const [systemSettings, setSystemSettings] = useState({
    tenantActive: true,
    maintenanceMessage: '',
    estimatedReturn: null
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSystemSettings = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        const configDoc = await getDoc(doc(db, 'config', 'systemSettings'));
        
        if (configDoc.exists()) {
          const data = configDoc.data();
          
          // Converte Firestore Timestamp para Date
          if (data.estimatedReturn && data.estimatedReturn.toDate) {
            data.estimatedReturn = data.estimatedReturn.toDate();
          }
          
          setSystemSettings(data);
        } else {
          // Se não existe documento, assume que está ativo (comportamento padrão)
          setSystemSettings({
            tenantActive: true,
            maintenanceMessage: 'Sistema temporariamente fora do ar. Estamos trabalhando para melhorar sua experiência.',
            estimatedReturn: null
          });
        }
      } catch (err) {
        console.error('Erro ao verificar status do sistema:', err);
        setError(err.message);
        
        // Em caso de erro, assume que está ativo para não bloquear o sistema
        setSystemSettings({
          tenantActive: true,
          maintenanceMessage: 'Sistema temporariamente fora do ar. Estamos trabalhando para melhorar sua experiência.',
          estimatedReturn: null
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadSystemSettings();
  }, []);

  const isSystemActive = () => {
    return systemSettings.tenantActive;
  };

  const isMasterUser = (user) => {
    return user && user.email === 'master@master.com';
  };

  const shouldShowMaintenance = (user) => {
    // Se o sistema está ativo, não mostra manutenção
    if (isSystemActive()) {
      return false;
    }
    
    // Se é usuário master, não mostra manutenção
    if (isMasterUser(user)) {
      return false;
    }
    
    // Para todos os outros usuários, mostra manutenção
    return true;
  };

  return {
    systemSettings,
    isLoading,
    error,
    isSystemActive: isSystemActive(),
    shouldShowMaintenance,
    isMasterUser
  };
};

export default useSystemStatus;
